import React from 'react';

import AlertsMenu from 'components/AlertsMenu';
import Popover from 'components/ui/Popover';
import AlertsButton from '../AlertsButton';

import css from './AlertsMenuPopover.module.scss';

const AlertsMenuPopover: React.FC = () => (
    <Popover
        ignoreClicks
        allowScroll
        offsetHorizontal={-130}
        offsetVertical={-6}
        className={css.triangle}
        content={<AlertsMenu isPopover />}
    >
        <AlertsButton />
    </Popover>
);

export default AlertsMenuPopover;
